const CHILDREN_CARRETERAS = [
  {
    id: 'autopitasYAutovias',
    description: 'Autopistas y Autovías',
    level: 1,
    defaultOpen: true,
    children: [
      'SalidaDeAutopista',
      'NumeroDeSalida',
      'MarcadorSalidaAutopista',
      'NudoDeCarretera',
      'NombreDeSalida',
      'DenominacionEuropea',
      'NombreDeAutopista',
      'AreasDeServicio',
      'AutopistaDePeaje',
      'AutopistasDePeajeEnConstruccion',
      'AutopistaInterna',
      'AutopistaLibreAutovia',
      'AutopistaLibreAutoviaEnConstruccion',
      'Multicarril',
      'MulticarrilEnConstruccion',
    ],
  },
  {
    id: 'redPrincipal',
    description: 'Red Principal',
    level: 1,
    defaultOpen: true,
    children: [
      'NombreDeCarreteraEstatal',
      'CarreteraDelEstado',
      'CarreteraDelEstadoEnConstruccion',
    ],
  },
  {
    id: 'redSecundaria',
    description: 'Red Secundaria',
    level: 1,
    defaultOpen: true,
    children: [
      'NombreCarreteraAutonomica1erOrden',
      'NombreCarreteraAutonomica2Orden',
      'AutonomicaDe1erOrden',
      'AutonomicaDe1erOrdenEnConstruccion',
      'AutonomicaDe2erOrden',
      'AutonomicaDe2erOrdenEnConstruccion',
      'AutonomicaDe3erOrden',
      'AutonomicaDe3erOrdenEnConstruccion',
    ],
  },
  {
    id: 'carreterasLocales',
    description: 'Carreteras locales',
    level: 1,
    defaultOpen: true,
    children: [
      'RedUrbana',
      'OtrasCarreteras',
    ],
  },
  {
    id: 'puntosKilometricos',
    description: 'Puntos Kilométricos',
    level: 1,
    defaultOpen: true,
    children: [
      'NumeroDePK',
      'DistanciaParcialMenor',
      'DistanciaParcialMayor',
      'DistanciaParcialEnAutopista',
      'Pks',
      'IndicadorDistanciaParcialAutopistas',
      'IndicadorDistanciaParcialMayor',
      'IndicadorDistanciaParcialMenor',
    ],
  },
  {
    id: 'puertosDeMontanya',
    description: 'Puertos de montaña',
    level: 1,
    defaultOpen: true,
    children: [
      'NombreDePuertoDeMontana',
      'GranPuertoDeMontana',
      'PuertosDeMontanaConProblemasDeNieve',
      'PuertosDeMontanaSinProblemasDeNieve',
    ],
  },
];
const CHILDREN_LUGARES_INTERES = [
  {
    id: 'sitiosDeInteres',
    description: 'Sitios de interés',
    level: 1,
    defaultOpen: true,
    children: [
      'Monumento',
      'Ermita',
      'Balneario',
      'Jardin',
      'Ruina',
      'Monasterio',
      'Cueva',
      'Castillo',
    ],
  },
  {
    id: 'alojamientos',
    description: 'Alojamientos',
    level: 1,
    defaultOpen: true,
    children: [
      'CasaRural',
      'Camping',
      'Parador',
    ],
  },
  {
    id: 'ocioYNaturaleza',
    description: 'Ocio y Naturaleza',
    level: 1,
    defaultOpen: true,
    children: [
      'CuadroNombredDePlayas',
      'IndicadorPlaya',
      'NombrePlaya',
      'Playas',
      'CampoDeGolf',
      'PuertoDeportivo',
      'ParquesNacionales',
      'EspacioProtegido',
    ],
  },
  {
    id: 'rutasDeInteres',
    description: 'Rutas de interés',
    level: 2,
    defaultOpen: true,
    children: [
      {
        id: 'caminoDeSantiago',
        description: 'Camino de Santiago',
        level: 1,
        defaultOpen: true,
        children: [
          'CaminoDeSantiago',
          'NombreDeCaminoDeSantiago',
          'IndicadorCaminoDeSantiago',
          'CuadroDeNombreDeCaminoDeSantiago',
        ],
      },
      {
        id: 'viaVerde',
        description: 'Vía Verde',
        level: 1,
        defaultOpen: true,
        children: [
          'ViaVerde',
          'NombreDeViaVerde',
        ],
      },
      {
        id: 'rutaTuristica',
        description: 'Ruta turística',
        level: 1,
        defaultOpen: true,
        children: [
          'NumeroRutaTuristica',
          'SimboloDeRutaTuristica',
          'RutaTuristica',
        ],
      },
    ],
  },
  {
    id: 'otrosLugaresDeInteres',
    description: 'Otros lugares de interés',
    level: 1,
    defaultOpen: true,
    children: [
      'Fotos',
      'Icnita',
    ],
  },
];
export const LAYERS_GROUP_TREE = [
  {
    id: 'carreteras',
    description: 'Carreteras',
    defaultOpen: true,
    level: 2,
    children: CHILDREN_CARRETERAS,
  },
  {
    id: 'ferrocarril',
    description: 'Ferrocarriles',
    level: 1,
    defaultOpen: true,
    children: [
      'AVE',
      'TunelEnAVE',
      'ViaAncha',
      'TunelEnViaAncha',
      'TunelEnViaEstrecha',
      'ViaEstrecha',
    ],
  },
  {
    id: 'poblaciones',
    description: 'Poblaciones',
    level: 1,
    defaultOpen: true,
    children: [
      'NombreDeAldea',
      'NombrePoblacionDeMenosDe5000hab',
      'NombrePoblacionEntre5000a25000hab',
      'NombrePoblacionDeMasDe25000hab',
      'Aldea',
      'MunicipioMenorDe5000Hab',
      'MunicipioEntre5000Y25000Hab',
      'MunicipioDeMasDe25000',
    ],
  },
  {
    id: 'obrasPublicas',
    description: 'Obras públicas',
    level: 1,
    defaultOpen: true,
    children: [
      'Tunel',
      'Aeropuerto',
      'Puente',
      'Presa',
      'EstacionFerrocarril',
      'Faro',
    ],
  },
  {
    id: 'lugaresDeInteres',
    description: 'Lugares de interés',
    level: 2,
    defaultOpen: true,
    children: CHILDREN_LUGARES_INTERES,
  },
  {
    id: 'relieve',
    description: 'Relieve',
    level: 1,
    defaultOpen: true,
    children: [],
  },
];
